import { render, staticRenderFns } from "./DatabaseTab.vue?vue&type=template&id=dcd81044&scoped=true&"
import script from "./DatabaseTab.vue?vue&type=script&lang=js&"
export * from "./DatabaseTab.vue?vue&type=script&lang=js&"
import style0 from "./DatabaseTab.vue?vue&type=style&index=0&id=dcd81044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd81044",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
